import React from 'react';

import ButtonGroup from '@atlaskit/button/button-group';
import Button from '@atlaskit/button/default/button';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';
import {
	PanelActionClose,
	PanelActionExpand,
	PanelActionGroup,
	PanelActionMore,
	PanelActionNewTab,
	PanelBody,
	PanelContainer,
	PanelFooter,
	PanelHeader,
	PanelTitle,
} from '@atlassian/panel-system';
import { PanelContent } from '@atlassian/panel-system/panel-content';

// This width is only set so the panel renders at a sensible size in the docs.
// Please use the navigation-system panel slot to size panels — do not hardcode this.
const styles = cssMap({
	exampleWrapper: {
		width: '400px',
		height: '480px',
	},
});

export default function BasicPanel(): React.JSX.Element {
	return (
		<Box xcss={styles.exampleWrapper}>
			<PanelContainer testId="basic-panel">
				<PanelHeader>
					<PanelTitle>Basic panel example</PanelTitle>
					<PanelActionGroup>
						<PanelActionExpand onClick={() => {}} />
						<PanelActionNewTab href="https://atlassian.design/components" />
						<PanelActionMore onClick={() => {}} />
						<PanelActionClose onClick={() => {}} />
					</PanelActionGroup>
				</PanelHeader>
				<PanelContent>
					<PanelBody>
						<Text as="p">This is a basic example of the panel system components.</Text>
						<Text as="p">
							The panel includes a header with a title and actions, and a body area for content.
						</Text>
					</PanelBody>
				</PanelContent>
				<PanelFooter>
					<ButtonGroup label="Panel actions">
						<Button appearance="subtle" onClick={() => {}}>
							Cancel
						</Button>
						<Button appearance="primary" onClick={() => {}}>
							Save
						</Button>
					</ButtonGroup>
				</PanelFooter>
			</PanelContainer>
		</Box>
	);
}
